<mat-toolbar class="secondary-toolbar mat-elevation-z1">
  <div *ngIf="state!='LIST'" class="secondary-toolbar-item selectable" (click)="showAllPlans()"><mat-icon>list</mat-icon> All Plans</div>
  <ng-container *ngIf="state=='EDIT'">
    <div class="secondary-toolbar-item"><mat-icon svgIcon="cw:action_next"></mat-icon>{{selectedPlan.name}}</div>
  </ng-container>
</mat-toolbar>

<section class="main-content">
  <cw-ci-admin-plan-list #planList *ngIf="state=='LIST'" (stateChange)="onStateChange($event)" ></cw-ci-admin-plan-list>
  <cw-ci-admin-plan-edit *ngIf="state=='EDIT' || state=='CREATE'" (stateChange)="onStateChange($event)" [plan]="selectedPlan"></cw-ci-admin-plan-edit>
</section>
